import React, { useEffect, useState } from "react";
import { resolveProps, resolveFns } from "../../../utils";
import { useTab } from "../../../hooks";
import "./index.scss";

import { AccordionProps, AccordionItem } from "./types";

const configs = {
  types: [
    {
      title: "default",
      isDefault: true,
    },
    "onlyChild",
  ],
  modifiers: [],
  states: [],
};

export default function Accordion(props: AccordionProps) {
  const {
    config,
    onlyChild = false,
    data = [],
    dataAccordion = [],
    inverse,
    ...rest
  } = props;

  useEffect(() => {
    useTab();
  }, []);

  const formatData = (data: AccordionItem[]) => {
    const formatedData = data.map((item)=> {
      const newItem = {...item, isOpen: !!item.isOpen}
      return newItem
    })
    return formatedData;
  }

  const [state, setState] = React.useState({data: formatData(props.data || props.dataAccordion)});

  function handleKeyPress(e, index) {
    if (e.charCode === 32 || e.charCode === 13) {
      handleBoxClick(e, index);
    }
  }

  function handleBoxClick(e, idx) {
    setState({
      data: state.data.map((item, index)=> {
        return {
          ...item, isOpen: (idx == index) ? !item.isOpen : false
        }
      })
    })
  }

  useEffect(()=>{
    setState({
      data: formatData(props.data || props.dataAccordion)
    })
  },[props.data, props.dataAccordion])

  return (
    <ul {...rest} className={`${resolveProps(props, configs, "Accordion")} ${inverse ? 'mdn-Accordion-box--inverse' : ''}`}>
      {state.data.map((item, index) => {
        const { gtm = {}, titleProps, title, content, onClick } = item;
        const { gtmClassName = "", dataGTM = {} } = gtm;

        return (
          <li
            key={`accordion_${index}`}
            onKeyDown={(e) => handleKeyPress(e, index)}
            className={`mdn-Accordion-box ${inverse ? 'mdn-Accordion-box--inverse ' : ''} ${ item.isOpen ? "is-expanded" : ""
              } `}
          >
            <button
              className={`mdn-Accordion-toggle mdn-Text mdn-Text--body ${gtmClassName}`}
              onClick={resolveFns((e) => handleBoxClick(e, index), onClick)}
              {...dataGTM}
              {...titleProps}
              aria-expanded={item.isOpen}
            >
              {item.titleTag
                ? React.createElement(item.titleTag, null, item.title)
                :
                <div className="mdn-Accordion-title">{title}</div>
              }
              <span className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--md" style={{ color: inverse ? 'var(--theme-color-neutral-lightest)' : 'var(--theme-color-neutral-darkest)' }}></span>
            </button>
            <div className="mdn-Accordion-content">{content}</div>
          </li>
        );
      })}
    </ul>
  );
}
